"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.setThemeStyling = exports.getVariantTextColor = exports.getVariantBgColor = exports.getTheme = exports.getTextColor = exports.getSmallCSS = exports.getPadding = exports.getHeight = exports.getFontSize = exports.getBorderRadius = exports.getBorder = exports.getBgColor = exports.disabled = exports.buttonVariantQueries = void 0;
require("core-js/modules/es6.regexp.split.js");
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _themeMapper = require("@gravity/theme-mapper");
var _themeProvider = require("@gravity/theme-provider");
var _utils = require("@gravity/utils");
var _lodash = require("lodash");
var _styledComponents = require("styled-components");
var _constants = require("./constants");
var _ThemeBuilder = _interopRequireDefault(require("./ThemeBuilder"));
var _types = require("./types");
var _excluded = ["currentTheme"],
  _excluded2 = ["variant"],
  _excluded3 = ["outline", "variant"],
  _excluded4 = ["variant"];
var _templateObject, _templateObject2, _templateObject3;
function cov_1bzwopsli9() {
  var path = "/codebuild/output/src3108803385/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Button/lib/helpers.js";
  var hash = "45b04f73146016e67692110cdb5e540212abeaea";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src3108803385/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Button/lib/helpers.js",
    statementMap: {
      "0": {
        start: {
          line: 11,
          column: 10
        },
        end: {
          line: 11,
          column: 68
        }
      },
      "1": {
        start: {
          line: 12,
          column: 19
        },
        end: {
          line: 12,
          column: 33
        }
      },
      "2": {
        start: {
          line: 22,
          column: 36
        },
        end: {
          line: 29,
          column: 1
        }
      },
      "3": {
        start: {
          line: 24,
          column: 13
        },
        end: {
          line: 28,
          column: 3
        }
      },
      "4": {
        start: {
          line: 24,
          column: 45
        },
        end: {
          line: 28,
          column: 3
        }
      },
      "5": {
        start: {
          line: 31,
          column: 26
        },
        end: {
          line: 34,
          column: 87
        }
      },
      "6": {
        start: {
          line: 32,
          column: 2
        },
        end: {
          line: 34,
          column: 87
        }
      },
      "7": {
        start: {
          line: 36,
          column: 27
        },
        end: {
          line: 37,
          column: 85
        }
      },
      "8": {
        start: {
          line: 37,
          column: 2
        },
        end: {
          line: 37,
          column: 85
        }
      },
      "9": {
        start: {
          line: 39,
          column: 26
        },
        end: {
          line: 39,
          column: 128
        }
      },
      "10": {
        start: {
          line: 39,
          column: 53
        },
        end: {
          line: 39,
          column: 128
        }
      },
      "11": {
        start: {
          line: 41,
          column: 25
        },
        end: {
          line: 47,
          column: 1
        }
      },
      "12": {
        start: {
          line: 42,
          column: 2
        },
        end: {
          line: 44,
          column: 3
        }
      },
      "13": {
        start: {
          line: 43,
          column: 4
        },
        end: {
          line: 43,
          column: 92
        }
      },
      "14": {
        start: {
          line: 46,
          column: 2
        },
        end: {
          line: 46,
          column: 73
        }
      },
      "15": {
        start: {
          line: 49,
          column: 28
        },
        end: {
          line: 50,
          column: 85
        }
      },
      "16": {
        start: {
          line: 50,
          column: 2
        },
        end: {
          line: 50,
          column: 85
        }
      },
      "17": {
        start: {
          line: 52,
          column: 31
        },
        end: {
          line: 57,
          column: 3
        }
      },
      "18": {
        start: {
          line: 53,
          column: 2
        },
        end: {
          line: 57,
          column: 3
        }
      },
      "19": {
        start: {
          line: 59,
          column: 25
        },
        end: {
          line: 60,
          column: 94
        }
      },
      "20": {
        start: {
          line: 60,
          column: 2
        },
        end: {
          line: 60,
          column: 94
        }
      },
      "21": {
        start: {
          line: 62,
          column: 27
        },
        end: {
          line: 68,
          column: 1
        }
      },
      "22": {
        start: {
          line: 62,
          column: 36
        },
        end: {
          line: 68,
          column: 1
        }
      },
      "23": {
        start: {
          line: 70,
          column: 33
        },
        end: {
          line: 71,
          column: 53
        }
      },
      "24": {
        start: {
          line: 71,
          column: 2
        },
        end: {
          line: 71,
          column: 53
        }
      },
      "25": {
        start: {
          line: 73,
          column: 35
        },
        end: {
          line: 74,
          column: 55
        }
      },
      "26": {
        start: {
          line: 74,
          column: 2
        },
        end: {
          line: 74,
          column: 55
        }
      },
      "27": {
        start: {
          line: 76,
          column: 24
        },
        end: {
          line: 80,
          column: 3
        }
      },
      "28": {
        start: {
          line: 77,
          column: 2
        },
        end: {
          line: 80,
          column: 3
        }
      },
      "29": {
        start: {
          line: 89,
          column: 31
        },
        end: {
          line: 90,
          column: 65
        }
      },
      "30": {
        start: {
          line: 90,
          column: 2
        },
        end: {
          line: 90,
          column: 65
        }
      },
      "31": {
        start: {
          line: 92,
          column: 24
        },
        end: {
          line: 101,
          column: 1
        }
      },
      "32": {
        start: {
          line: 93,
          column: 2
        },
        end: {
          line: 95,
          column: 3
        }
      },
      "33": {
        start: {
          line: 94,
          column: 4
        },
        end: {
          line: 94,
          column: 17
        }
      },
      "34": {
        start: {
          line: 97,
          column: 2
        },
        end: {
          line: 100,
          column: 11
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 24,
            column: 2
          },
          end: {
            line: 24,
            column: 3
          }
        },
        loc: {
          start: {
            line: 24,
            column: 13
          },
          end: {
            line: 28,
            column: 3
          }
        },
        line: 24
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 24,
            column: 13
          },
          end: {
            line: 24,
            column: 14
          }
        },
        loc: {
          start: {
            line: 24,
            column: 45
          },
          end: {
            line: 28,
            column: 3
          }
        },
        line: 24
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 31,
            column: 26
          },
          end: {
            line: 31,
            column: 27
          }
        },
        loc: {
          start: {
            line: 32,
            column: 2
          },
          end: {
            line: 34,
            column: 87
          }
        },
        line: 32
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 36,
            column: 27
          },
          end: {
            line: 36,
            column: 28
          }
        },
        loc: {
          start: {
            line: 37,
            column: 2
          },
          end: {
            line: 37,
            column: 85
          }
        },
        line: 37
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 39,
            column: 26
          },
          end: {
            line: 39,
            column: 27
          }
        },
        loc: {
          start: {
            line: 39,
            column: 53
          },
          end: {
            line: 39,
            column: 128
          }
        },
        line: 39
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 41,
            column: 25
          },
          end: {
            line: 41,
            column: 26
          }
        },
        loc: {
          start: {
            line: 41,
            column: 61
          },
          end: {
            line: 47,
            column: 1
          }
        },
        line: 41
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 49,
            column: 28
          },
          end: {
            line: 49,
            column: 29
          }
        },
        loc: {
          start: {
            line: 50,
            column: 2
          },
          end: {
            line: 50,
            column: 85
          }
        },
        line: 50
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 52,
            column: 31
          },
          end: {
            line: 52,
            column: 32
          }
        },
        loc: {
          start: {
            line: 53,
            column: 2
          },
          end: {
            line: 57,
            column: 3
          }
        },
        line: 53
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 59,
            column: 25
          },
          end: {
            line: 59,
            column: 26
          }
        },
        loc: {
          start: {
            line: 60,
            column: 2
          },
          end: {
            line: 60,
            column: 94
          }
        },
        line: 60
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 62,
            column: 27
          },
          end: {
            line: 62,
            column: 28
          }
        },
        loc: {
          start: {
            line: 62,
            column: 36
          },
          end: {
            line: 68,
            column: 1
          }
        },
        line: 62
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 70,
            column: 33
          },
          end: {
            line: 70,
            column: 34
          }
        },
        loc: {
          start: {
            line: 71,
            column: 2
          },
          end: {
            line: 71,
            column: 53
          }
        },
        line: 71
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 73,
            column: 35
          },
          end: {
            line: 73,
            column: 36
          }
        },
        loc: {
          start: {
            line: 74,
            column: 2
          },
          end: {
            line: 74,
            column: 55
          }
        },
        line: 74
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 76,
            column: 24
          },
          end: {
            line: 76,
            column: 25
          }
        },
        loc: {
          start: {
            line: 77,
            column: 2
          },
          end: {
            line: 80,
            column: 3
          }
        },
        line: 77
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 89,
            column: 31
          },
          end: {
            line: 89,
            column: 32
          }
        },
        loc: {
          start: {
            line: 90,
            column: 2
          },
          end: {
            line: 90,
            column: 65
          }
        },
        line: 90
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 92,
            column: 24
          },
          end: {
            line: 92,
            column: 25
          }
        },
        loc: {
          start: {
            line: 92,
            column: 67
          },
          end: {
            line: 101,
            column: 1
          }
        },
        line: 92
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 32,
            column: 2
          },
          end: {
            line: 34,
            column: 87
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 33,
            column: 6
          },
          end: {
            line: 33,
            column: 68
          }
        }, {
          start: {
            line: 34,
            column: 6
          },
          end: {
            line: 34,
            column: 87
          }
        }],
        line: 32
      },
      "1": {
        loc: {
          start: {
            line: 42,
            column: 2
          },
          end: {
            line: 44,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 42,
            column: 2
          },
          end: {
            line: 44,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 42
      },
      "2": {
        loc: {
          start: {
            line: 46,
            column: 9
          },
          end: {
            line: 46,
            column: 72
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 46,
            column: 46
          },
          end: {
            line: 46,
            column: 63
          }
        }, {
          start: {
            line: 46,
            column: 66
          },
          end: {
            line: 46,
            column: 72
          }
        }],
        line: 46
      },
      "3": {
        loc: {
          start: {
            line: 71,
            column: 2
          },
          end: {
            line: 71,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 71,
            column: 2
          },
          end: {
            line: 71,
            column: 26
          }
        }, {
          start: {
            line: 71,
            column: 30
          },
          end: {
            line: 71,
            column: 53
          }
        }],
        line: 71
      },
      "4": {
        loc: {
          start: {
            line: 74,
            column: 2
          },
          end: {
            line: 74,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 74,
            column: 2
          },
          end: {
            line: 74,
            column: 30
          }
        }, {
          start: {
            line: 74,
            column: 34
          },
          end: {
            line: 74,
            column: 55
          }
        }],
        line: 74
      },
      "5": {
        loc: {
          start: {
            line: 78,
            column: 24
          },
          end: {
            line: 78,
            column: 69
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 78,
            column: 24
          },
          end: {
            line: 78,
            column: 42
          }
        }, {
          start: {
            line: 78,
            column: 46
          },
          end: {
            line: 78,
            column: 69
          }
        }],
        line: 78
      },
      "6": {
        loc: {
          start: {
            line: 79,
            column: 13
          },
          end: {
            line: 79,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 79,
            column: 13
          },
          end: {
            line: 79,
            column: 35
          }
        }, {
          start: {
            line: 79,
            column: 39
          },
          end: {
            line: 79,
            column: 60
          }
        }],
        line: 79
      },
      "7": {
        loc: {
          start: {
            line: 92,
            column: 27
          },
          end: {
            line: 92,
            column: 37
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 92,
            column: 35
          },
          end: {
            line: 92,
            column: 37
          }
        }],
        line: 92
      },
      "8": {
        loc: {
          start: {
            line: 93,
            column: 2
          },
          end: {
            line: 95,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 93,
            column: 2
          },
          end: {
            line: 95,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 93
      },
      "9": {
        loc: {
          start: {
            line: 93,
            column: 6
          },
          end: {
            line: 93,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 93,
            column: 6
          },
          end: {
            line: 93,
            column: 29
          }
        }, {
          start: {
            line: 93,
            column: 33
          },
          end: {
            line: 93,
            column: 66
          }
        }],
        line: 93
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0],
      "8": [0, 0],
      "9": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "45b04f73146016e67692110cdb5e540212abeaea"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1bzwopsli9 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1bzwopsli9();
var _ = (cov_1bzwopsli9().s[0]++, {
  get: _lodash.get,
  set: _lodash.set,
  cloneDeep: _lodash.cloneDeep,
  tail: _lodash.tail,
  split: _lodash.split,
  mapValues: _lodash.mapValues,
  zipObject: _lodash.zipObject
});
var _ref = (cov_1bzwopsli9().s[1]++, _themeMapper.evolutionTheme),
  button = _ref.button;

/**
 * Object containing CSS styles for button variants.
 * @type {{
 *   primary: ThemedCssFunction<any>,
 *   secondary: ThemedCssFunction<any>,
 *   tertiary: ThemedCssFunction<any>
 * }}
 */
var buttonVariantQueries = exports.buttonVariantQueries = (cov_1bzwopsli9().s[2]++, _.mapValues(_.zipObject(_types.buttonVariants, _types.buttonVariants), function (variant) {
  cov_1bzwopsli9().f[0]++;
  cov_1bzwopsli9().s[3]++;
  return function (strings) {
    cov_1bzwopsli9().f[1]++;
    cov_1bzwopsli9().s[4]++;
    for (var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }
    return (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n    &.g-Button-", " {\n      ", ";\n    }\n  "])), variant, (0, _styledComponents.css)(strings, interpolations));
  };
}));
cov_1bzwopsli9().s[5]++;
var getPadding = exports.getPadding = function getPadding(_ref2) {
  var theme = _ref2.theme,
    currentTheme = _ref2.currentTheme;
  cov_1bzwopsli9().f[2]++;
  cov_1bzwopsli9().s[6]++;
  return currentTheme === _themeProvider.TicketShopTheme.EQUILIBRIUM ? (cov_1bzwopsli9().b[0][0]++, _constants.DEFAULT_STYLING_CONSTANTS[_themeProvider.TicketShopTheme.EQUILIBRIUM].padding) : (cov_1bzwopsli9().b[0][1]++, _.get(theme, _constants.THEME_PATH.padding, _constants.DEFAULT_STYLING_CONSTANTS[currentTheme].padding));
};
cov_1bzwopsli9().s[7]++;
var getFontSize = exports.getFontSize = function getFontSize(_ref3) {
  var currentTheme = _ref3.currentTheme,
    props = (0, _objectWithoutProperties2.default)(_ref3, _excluded);
  cov_1bzwopsli9().f[3]++;
  cov_1bzwopsli9().s[8]++;
  return _.get(props, _constants.THEME_PATH.fontSize, _constants.DEFAULT_STYLING_CONSTANTS[currentTheme].fontSize);
};
cov_1bzwopsli9().s[9]++;
var getBgColor = exports.getBgColor = function getBgColor(_ref4) {
  var variant = _ref4.variant,
    props = (0, _objectWithoutProperties2.default)(_ref4, _excluded2);
  cov_1bzwopsli9().f[4]++;
  cov_1bzwopsli9().s[10]++;
  return "var(--".concat(variant, "Color, ").concat(_.get(props, "theme.".concat(variant, "Color"), 'white'), ")");
};
cov_1bzwopsli9().s[11]++;
var getBorder = exports.getBorder = function getBorder(_ref5) {
  var outline = _ref5.outline,
    variant = _ref5.variant,
    props = (0, _objectWithoutProperties2.default)(_ref5, _excluded3);
  cov_1bzwopsli9().f[5]++;
  cov_1bzwopsli9().s[12]++;
  if (outline) {
    cov_1bzwopsli9().b[1][0]++;
    cov_1bzwopsli9().s[13]++;
    return "".concat((0, _lodash.get)(props, 'theme.borderAndDividerWidth', '1px'), " solid ").concat(getBgColor(props));
  } else {
    cov_1bzwopsli9().b[1][1]++;
  }
  cov_1bzwopsli9().s[14]++;
  return variant === _types.ButtonVariant.tertiary ? (cov_1bzwopsli9().b[2][0]++, (0, _utils.border)()) : (cov_1bzwopsli9().b[2][1]++, 'none');
};
cov_1bzwopsli9().s[15]++;
var getTextColor = exports.getTextColor = function getTextColor(_ref6) {
  var variant = _ref6.variant,
    props = (0, _objectWithoutProperties2.default)(_ref6, _excluded4);
  cov_1bzwopsli9().f[6]++;
  cov_1bzwopsli9().s[16]++;
  return "var(--".concat(variant, "TextColor, ").concat(_.get(props, "theme.".concat(variant, "TextColor"), 'black'), ")");
};
cov_1bzwopsli9().s[17]++;
var getBorderRadius = exports.getBorderRadius = function getBorderRadius(props) {
  cov_1bzwopsli9().f[7]++;
  cov_1bzwopsli9().s[18]++;
  return _.get(props, _constants.THEME_PATH.borderRadius, _constants.DEFAULT_STYLING_CONSTANTS[_themeProvider.TicketShopTheme.EVOLUTION].borderRadius);
};
cov_1bzwopsli9().s[19]++;
var getHeight = exports.getHeight = function getHeight(props) {
  cov_1bzwopsli9().f[8]++;
  cov_1bzwopsli9().s[20]++;
  return _.get(props, _constants.THEME_PATH.height, _constants.DEFAULT_STYLING_CONSTANTS[_themeProvider.TicketShopTheme.EVOLUTION].height);
};
cov_1bzwopsli9().s[21]++;
var getSmallCSS = exports.getSmallCSS = function getSmallCSS(props) {
  cov_1bzwopsli9().f[9]++;
  cov_1bzwopsli9().s[22]++;
  return (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  height: ", ";\n"])), _.get(props, _constants.THEME_PATH.smallHeight, _constants.DEFAULT_STYLING_CONSTANTS[_themeProvider.TicketShopTheme.EVOLUTION].smallHeight));
};
cov_1bzwopsli9().s[23]++;
var getVariantBgColor = exports.getVariantBgColor = function getVariantBgColor(_ref7) {
  var theme = _ref7.theme,
    variant = _ref7.variant;
  cov_1bzwopsli9().f[10]++;
  cov_1bzwopsli9().s[24]++;
  return (cov_1bzwopsli9().b[3][0]++, theme["".concat(variant, "Color")]) || (cov_1bzwopsli9().b[3][1]++, button[variant].bgColor);
};
cov_1bzwopsli9().s[25]++;
var getVariantTextColor = exports.getVariantTextColor = function getVariantTextColor(_ref8) {
  var theme = _ref8.theme,
    variant = _ref8.variant;
  cov_1bzwopsli9().f[11]++;
  cov_1bzwopsli9().s[26]++;
  return (cov_1bzwopsli9().b[4][0]++, theme["".concat(variant, "TextColor")]) || (cov_1bzwopsli9().b[4][1]++, button[variant].color);
};
cov_1bzwopsli9().s[27]++;
var disabled = exports.disabled = function disabled(_ref9) {
  var theme = _ref9.theme;
  cov_1bzwopsli9().f[12]++;
  cov_1bzwopsli9().s[28]++;
  return (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n    background-color: ", ";\n    color: ", ";\n  "])), (cov_1bzwopsli9().b[5][0]++, theme.disableColor) || (cov_1bzwopsli9().b[5][1]++, button.disabled.bgColor), (cov_1bzwopsli9().b[6][0]++, theme.disableTextColor) || (cov_1bzwopsli9().b[6][1]++, button.disabled.color));
};

/**
 * Sets a specific styling property in the given props object.
 * @param {object} props - The props object to set the styling property in.
 * @param {'bg' | 'textColor' | 'fontSize' | 'borderRadius'} property - The property to set (e.g., 'bg', 'textColor', 'fontSize', 'borderRadius').
 * @param {any} value - The value to set for the property.
 * @returns {object} - The theme result
 */
cov_1bzwopsli9().s[29]++;
var setThemeStyling = exports.setThemeStyling = function setThemeStyling(theme, property, value) {
  cov_1bzwopsli9().f[13]++;
  cov_1bzwopsli9().s[30]++;
  return _.set(theme, _.tail(_.split(_constants.THEME_PATH[property], '.')), value);
};
cov_1bzwopsli9().s[31]++;
var getTheme = exports.getTheme = function getTheme(_ref10) {
  var _ref10$theme = _ref10.theme,
    theme = _ref10$theme === void 0 ? (cov_1bzwopsli9().b[7][0]++, {}) : _ref10$theme,
    themeQueries = _ref10.themeQueries,
    variant = _ref10.variant;
  cov_1bzwopsli9().f[14]++;
  cov_1bzwopsli9().s[32]++;
  if ((cov_1bzwopsli9().b[9][0]++, !themeQueries.EVOLUTION) || (cov_1bzwopsli9().b[9][1]++, _types.ButtonVariant.primary === variant)) {
    cov_1bzwopsli9().b[8][0]++;
    cov_1bzwopsli9().s[33]++;
    return theme;
  } else {
    cov_1bzwopsli9().b[8][1]++;
  }
  cov_1bzwopsli9().s[34]++;
  return new _ThemeBuilder.default(theme).withBg(getVariantBgColor({
    theme: theme,
    variant: variant
  })).withTextColor(getVariantTextColor({
    theme: theme,
    variant: variant
  })).get();
};